<script setup lang="ts"></script>
<template>
	<p class="mb-2 text-xs text-bright-orange">
		<span>
			Please add the bot to your Zulip stream<br />
			portalsupport-bot@lpc-zulip2-u22.jcaelectronics.ca
		</span>
	</p>
</template>
